import React, {Component} from 'react'
import './SearchArea.css'


class SearchArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
           basicSearchWord:"查詢全欄位，可用 AND、OR 布林邏輯",
           //advancedSearchToggle:false,
           advancedSearchOption:"Event_SysID",
           advancedSearchWord:"以關鍵字查詢指定欄位",
        }
    }

  

    componentDidMount(){

    }

    onBasicSearchWordInput=(e)=>{
        e.stopPropagation();
        if(e.target.value !== this.state.basicSearchWord)
        {
            this.setState({basicSearchWord:e.target.value})
        }
    }

    onAdvancedSearchWordInput=(e)=>{
        e.stopPropagation();
        if(e.target.value !== this.state.advancedSearchWord)
        {
            this.setState({advancedSearchWord:e.target.value})
        }
    }

    advancedSearchToggle=(e)=>{
        e.preventDefault()
        e.stopPropagation()
        this.setState(prevState=>({
            advancedSearchToggle:!prevState.advancedSearchToggle
        }))
    }

    changeAdvancedSelectValue=(e)=>{
        e.stopPropagation();
        if(e.target.value !== this.state.advancedSearchOption)
        {
            this.setState({advancedSearchOption:e.target.value})
        }
    }
    
    onClick = () => {
        console.log("fuck you don't click me !")
    }

    handleSearchInfo = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if(this.state.basicSearchWord !== "查詢全欄位，可用 AND、OR 布林邏輯")
        {
            if(this.state.basicSearchWord !=="")
            {
                let roughWords = this.roughParser(this.state.basicSearchWord)
                let outputWords = this.advanceParser(roughWords)
                console.log("keywords parser finish...")
                console.log(outputWords)
                this.props.getSearchInfo(outputWords)
            }
            else
            {
                let emptyArray = []
                this.props.getSearchInfo(emptyArray)
            }
        }
    }

    roughParser = (text) =>{
        let patt1 = /[^\s]+/g
        let outputRough = text.match(patt1)
        console.log("rough parsering...")
        console.log(text)
        console.log(outputRough)
        return outputRough
    }

    advanceParser = (roughKeywords) => {
        let output = []
        var i
        for(i=0;i<roughKeywords.length;i++)
        {
            if(i===0)
            {
                if(roughKeywords[i] !== "AND"  && roughKeywords[i] !== "OR")
                {
                    let key = {
                        type:"AND",
                        word:roughKeywords[i]
                        
                    }
                    output.push(key)
                } 
            }
            else
            {
                if(roughKeywords[i-1] === "OR")
                {
                    if(roughKeywords[i] !== "AND" && roughKeywords[i] !== "OR")
                    {
                        let key = {
                            type:"OR",
                            word:roughKeywords[i],
                        }
                        output.push(key)
                    } 
                }
                else
                {
                    if(roughKeywords[i] !== "AND" && roughKeywords[i] !== "OR")
                    {
                        let key = { 
                            type:"AND",
                            word:roughKeywords[i],
                        }
                        output.push(key)
                    }
                }
            }
        }
        return output
    }


    advancedSearchAreaShowOrNot = () => {
        console.log("proceed advancedSearchAreaShowOrNot... ")
        if(this.state.advancedSearchToggle)
        {
            let inputTextDefaultStyle = {
                display: "inline-block",
                width:"360px",
                height:"30px",
                fontSize: "15px",
                fontFamily:"Microsoft JhengHei",
                border: "1px solid transparent",
                borderRadius: "4px 0px 0px 4px",  
                backgroundColor:"#ffffff",
                color: "#c4c4c4"
            }
    
            let inputTextStyle = {
                display: "inline-block",
                width:"360px",
                height:"30px",
                fontSize: "15px",
                fontFamily:"Microsoft JhengHei",
                border: "1px solid transparent",
                borderRadius: "4px 0px 0px 4px",  
                backgroundColor:"#ffffff",
                color: "#000000"
            }
            return (
                <form>
                    <select value={this.state.advancedSearchOption} onChange={this.changeAdvancedSelectValue} className="advancedSearchSelect">
                        <option value="Event_SysID">專題系統編號</option>
                        <option value="Event_Title">專題標題</option>
                        <option value="Event_EditedDate">專題建立日期</option>
                        <option value="User_Name">專題建立者</option>
                        <option value="Event_SubTitle">專題副標題</option>
                        <option value="Event_Story">專題大綱</option>
                        <option value="Event_StartDate">專題起始日期</option>
                        <option value="Event_EndDate">專題結束日期</option>
                    </select>
                    <input style={this.state.advancedSearchWord === "以關鍵字查詢指定欄位" ? inputTextDefaultStyle:inputTextStyle} type="text" value={this.state.advancedSearchWord} onChange={this.onAdvancedSearchWordInput} />
                    <input className="InputSubmitSearchArea" value="查詢" onClick={this.handleSearchInfo}/>   
                </form>
            )
        }
        else
        {
            return null
        }
    }

    render(){
        let inputTextDefaultStyle = {
            display: "inline-block",
            width:"360px",
            height:"30px",
            fontSize: "15px",
            fontFamily:"Microsoft JhengHei",
            border: "1px solid transparent",
            borderRadius: "4px 0px 0px 4px",  
            backgroundColor:"#ffffff",
            color: "#c4c4c4"
        }

        let inputTextStyle = {
            display: "inline-block",
            width:"360px",
            height:"30px",
            fontSize: "15px",
            fontFamily:"Microsoft JhengHei",
            border: "1px solid transparent",
            borderRadius: "4px 0px 0px 4px",  
            backgroundColor:"#ffffff",
            color: "#000000"
        }


        return(
        <div className="SearchArea">
            <div className="basicSearchArea">
                <form>
                    <input style={this.state.basicSearchWord === "查詢全欄位，可用 AND、OR 布林邏輯" ? inputTextDefaultStyle:inputTextStyle} type="text" value={this.state.basicSearchWord} onChange={this.onBasicSearchWordInput} />
                    <input className="InputSubmitSearchArea" value="查詢" onClick={this.handleSearchInfo}/>         
                </form>
               
                <form style={{marginLeft:"10px"}}>
                    <select value={this.state.advancedSearchOption} onChange={this.changeAdvancedSelectValue} className="advancedSearchSelect">
                        <option value="Event_SysID">專題系統編號</option>
                        <option value="Event_Title">專題標題</option>
                        <option value="Event_EditedDate">專題建立日期</option>
                        <option value="User_Name">專題建立者</option>
                        <option value="Event_SubTitle">專題副標題</option>
                        <option value="Event_Story">專題大綱</option>
                        <option value="Event_StartDate">專題起始日期</option>
                        <option value="Event_EndDate">專題結束日期</option>
                    </select>
                    <input style={this.state.advancedSearchWord === "以關鍵字查詢指定欄位" ? inputTextDefaultStyle:inputTextStyle} type="text" value={this.state.advancedSearchWord} onChange={this.onAdvancedSearchWordInput} />
                    <input className="InputSubmitSearchArea" value="查詢" onClick={this.handleSearchInfo}/>   
                </form>
            </div>
    
        </div>    
        )
    }

}

export default SearchArea